module.exports = __webpack_public_path__ + "assets/img/hyx_1.2c9345a2.png";